import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GeoZoneService } from '../../../../../services/geo_zone/geo_zone.service';
import { Loginshared } from '../../../../../services/sharedservices/loginshared.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { errorMessages } from './../../../././././../../configurations/errorMessages';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../services/common_Service/common.service';
import { SessionHelper } from '../../../../../services/localstorage';


@Component({
    selector: 'app-addGeoZone',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})
export class AddComponentGeoZone implements OnInit {

    isCreateNewShow: boolean = true;
    contentReadyToReview: boolean = false;
    shareMassage: any;
    isUserLoggedIn: boolean;
    createGeoZoneForm: FormGroup;
    isGeoZoneSubmitted: boolean = false;
    geoMapping: any = {};
    mapping: any = [];
    geoZoneList = [];
    errorMessages = errorMessages;
    loader: boolean = false;
    update: boolean = false;
    id: any;
    //Dynaic fromArray
    variableForm: FormGroup;
    items: FormArray;
    countryFilterObj: any;
    geoMappingFilter: any = {};
    geoZoneFormData: any = {};
    geoMappingSelectionFlag: boolean = false;
    filterObj: any = {};
    filtergeoObj: any = {};
    selectedItem = [];
    isDeleteAction: boolean = false;
    deleteGeoMappingIndex: any;
    isHeaderVisible:boolean=false;


    //@Input() contentId:any;
    @Output() updateSend = new EventEmitter<any>();
    config: { id: 'pagination2', itemsPerPage: number; currentPage: number; totalItems: any; };
    start: any;
    limit: number = 10;
    activecurrentPage: number = 1;
    deleteGeoMapping: any = [];
    searcherrormsg: boolean = false;

    //New Code start
    @Input() set contentId(value: any) {

        this.isGeoZoneSubmitted = false;

        if (value == 'reset') {

            this.resetForm();

        } else {
            //start code for hide create new button
            if (value != 'null') {
                this.showCreateNewButton('hide');
            }
            //end code for hide create new button
            this.onLoad(value);
        }

    }
    //New Code end

    editorConfig = {
        "toolbar": [
            ["bold", "italic", "underline"],
            ["justifyLeft", "justifyCenter", "justifyRight"]
        ]
    }

    applyBlackTheme = localStorage.getItem('boolThemeFlag');

    constructor(private commonService: CommonService, private toastrService: ToastrService, private activatedRoute: ActivatedRoute, private loginSharedService: Loginshared, private router: Router, private geoZoneService: GeoZoneService, private formBuilder: FormBuilder) {
        loginSharedService.sendUserLoggedIn$.subscribe(mission => {
            this.isUserLoggedIn = mission;
            let uid = localStorage.getItem('ud');
            if (uid !== undefined && uid != null) {
                this.isUserLoggedIn = true;
            }
        });
    }

    roleAsses: any = {};
    roleConfiguration: any = [];
    ngOnInit() {
        this.filtergeoObj = {};
        this.config = {
            id: 'pagination2',
            itemsPerPage: 10,
            currentPage: 1,
            totalItems: 0
        };
        this.roleAsses.geoZoneEdit = false;
        this.roleAsses.geoZone = false;
        this.roleAsses.geoZoneCreate = false;

        this.roleConfiguration = SessionHelper.getRole();

        this.roleConfiguration.forEach((element, i) => {

            if ((element.isView == 1 && element.pageTitle == 'Geo Zone')) {

                this.roleAsses.geoZone = true;
            }

            if ((element.isEdit == 1 && element.pageTitle == 'Geo Zone')) {

                this.roleAsses.geoZoneEdit = true;
            }

            if ((element.isCreate == 1 && element.pageTitle == 'Geo Zone')) {

                this.roleAsses.geoZoneCreate = true;

            }
        })
        // theme update code start
        this.commonService.currentThemelight.subscribe((result: any) => {

            this.applyBlackTheme = localStorage.getItem('boolThemeFlag');

        })
        // theme update code start
    }

    editCreate: boolean = false;
    onCreateNew() {

        if (this.roleAsses.geoZoneCreate == true) {

            this.editCreate = true;
        }

        this.isCreateNewShow = false

    }

    onLoad(id) {


        if (id != 'null' && this.roleAsses.geoZoneEdit == true) {

            this.editCreate = true;

        } else {

            this.editCreate = false;

        }

        this.geoMappingFilter = {};


        let uid = localStorage.getItem('ud');
        if (uid !== undefined && uid != null) {

        } else {
            this.router.navigate(['/login']);
        }

        let headerTitle = {
            title: 'Master',
            subTitle: 'Geo Zone'
        }

        this.commonService.changeHeaderTitle(headerTitle);

        this.createGeoZoneForm = this.formBuilder.group({
            geoZoneName: ['', Validators.compose([Validators.required])],
            // latitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            latitude: [''],
            // mapAssetGroup:[[]],
            longitude: [''],
            // longitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            description: [''],
            isActive: ['1'],
            mapGeoMapping: [[]],
            deletedGeoMapping: [[]],
            id: [''],
            contentState: ['In-Progress'],
            publisherState: ['Un-published'],
            reviewerState: ['Un-approved'],
            created_by: [localStorage.getItem('ud')],
        });

        //add dynamic field
        this.variableForm = this.formBuilder.group({
            items: this.formBuilder.array([this.createItem()])
        });


        this.id = id; // (+) converts string 'id' to a number
        if (this.id != 'null') {

            console.log('this.id===>>>', this.id);
            this.update = true;
            this.activecurrentPage = 1;
            this.getGeoZoneInfo(this.id, false, 0, 10);

        } else {
            this.getAllGeoZone(this.filterObj, 0, 10);
            this.update = false;
        }

    }


    get l() { return this.createGeoZoneForm.controls; }
    get l_i() { let objItems = this.variableForm.get('items') as FormArray; return objItems.controls; }

    getAllGeoZone(obj, start, limit) {
        this.geoZoneService.getGeoZoneList()
            .subscribe((result: any) => {

                this.geoZoneList = [];
                if (result.data.data.length > 0) {
                    for (let geoZoneObj of result.data.data) {

                        this.geoZoneList.push(
                            {
                                'id': geoZoneObj.geoZoneId,
                                'itemName': geoZoneObj.geoZoneName

                            });
                    }
                }
                console.log(this.geoZoneList);
            })
    }

    getGeoZoneInfo(id, filter, start, limit) {
        console.log(filter)
        if (filter == false) {
            this.filterObj = {};
        }
        this.commonService.changeloader(true);

        this.commonService.changeloader(false);
        this.geoZoneService.getGeoZone(id, this.filtergeoObj, start, limit)
            .subscribe((result: any) => {
                this.filtergeoObj = {};
                // this.loader=false;
                this.commonService.changeloader(false);
                console.log("result==========>", result);
                this.createGeoZoneForm.controls['geoZoneName'].setValue(result.data[0].geoZoneName);
                this.createGeoZoneForm.controls['latitude'].setValue(result.data[0].latitude);
                this.createGeoZoneForm.controls['longitude'].setValue(result.data[0].longitude);
                this.createGeoZoneForm.controls['description'].setValue(result.data[0].description);
                this.createGeoZoneForm.controls['isActive'].setValue(result.data[0].isActive.toString());

                // console.log("result.data[0].results.geoMapping[0]=========>>>>>>>>... ",result.data[0].geoMapping[0]);

                this.createGeoZoneForm.controls['publisherState'].setValue(result.data[0].publisherState);
                this.createGeoZoneForm.controls['reviewerState'].setValue(result.data[0].reviewerState);

                if (result.data[0].contentState == null || result.data[0].contentState == '' || result.data[0].contentState == undefined) {
                    this.createGeoZoneForm.controls['contentState'].setValue(['In-Progress']);
                }
                else {
                    this.createGeoZoneForm.controls['contentState'].setValue(result.data[0].contentState);
                }

                if (result.data[0].geoMapping.length > 0) {

                    this.variableForm = this.formBuilder.group({
                        items: this.formBuilder.array([])
                    });
                    // (this.variableForm.controls['other_Partners'] as FormArray).clear();

                    this.items = this.variableForm.get('items') as FormArray;
                    this.items.reset()
                    this.geoZoneFormData = result.data[0].geoMapping;
                    this.loader = true
                    this.config = {
                        id: 'pagination2',
                        itemsPerPage: 10,
                        currentPage: this.activecurrentPage,
                        totalItems: result.data[0].totalCount
                    };
                    console.log(result.data[0].geoMapping.length)
                    for (let i = 0; i < result.data[0].geoMapping.length; i++) {

                        setTimeout(() => {

                            console.log("123", result.data[0].geoMapping[i]);

                            this.items.push(this.updateItem(result.data[0].geoMapping[i], i));

                        }, 1000);
                        this.geoZoneFormData[i]['addNewItemFlag'] = false;

                    }
                    // this.geoZoneFormData=result.data[0].geoMapping;
                    this.loader = false
                    console.log("===============================================", this.items);

                }
                else {
                    this.variableForm = this.formBuilder.group({
                        items: this.formBuilder.array([])
                    });
                }

            });
    }
    pageChanged(event) {

        console.log("event>>", event);


        let pageInfo = [{

            // 'count': 13,
            'limit': 10,
            'offset': event - 1,
            'pageSize': 10,
            'id': 2

        }]
        this.activecurrentPage = event;
        console.log("pageInfo", pageInfo);

        if (pageInfo[0].offset === 0) {

            this.start = 0;
            this.getGeoZoneInfo(this.id, false, this.start, this.limit)

        } else {

            this.start = (this.limit * (pageInfo[0].offset));
            this.getGeoZoneInfo(this.id, false, this.start, this.limit)
        }

    }

    savecreateGeoZone() {


        console.log("this.createGeoZoneForm=true;", this.createGeoZoneForm.value);

        // this.loader = true;
        this.commonService.changeloader(true);

        this.isGeoZoneSubmitted = true;
        this.createGeoZoneForm.controls['mapGeoMapping'].setValue(this.variableForm.value.items);
        if (!this.createGeoZoneForm.valid) {
            // this.loader = false;
            this.commonService.changeloader(false);
            return;
        }


        if (this.update == true) {

            if (this.roleAsses.getGeoEdit == false) {
                this.toastrService.success('no access to edit.');
                this.commonService.changeloader(false);
                return;
            }

            console.log(this.deleteGeoMapping)
            this.createGeoZoneForm.controls['deletedGeoMapping'].setValue(this.deleteGeoMapping);
            this.createGeoZoneForm.controls['id'].setValue(this.id);
            console.log(this.createGeoZoneForm.value);
            this.geoZoneService.updateGeoZone(this.createGeoZoneForm.value)
                .subscribe((result: any) => {

                    // this.loader=false;
                    this.commonService.changeloader(false);

                    // this.router.navigate(['master/geo_zone/list']);

                    //New Code for right side for from
                    this.update = false;
                    //   this.updateSend.emit();
                    this.resetForm();
                    this.isGeoZoneSubmitted = false;
                    // this.addNewItemFlag=false;
                    this.toastrService.success('Geo Zone  Updated Successfully.');
                    console.log('this.result===>>>', result);

                })
        }

        if (this.update == false) {

            if (this.roleAsses.geoZoneCreate == false) {
                this.toastrService.success('no access to create.');
                this.commonService.changeloader(false);
                return;
            }

            this.createGeoZoneForm.value.id = undefined;

            console.log(this.createGeoZoneForm);
            this.commonService.changeloader(false);


            this.geoZoneService.insertGeoZone(this.createGeoZoneForm.value)
                .subscribe((result: any) => {

                    // this.loader=false;
                    this.commonService.changeloader(false);

                    // this.router.navigate(['master/geo_zone/list']);

                    //New Code for right side for from
                    this.update = false;
                    //  this.updateSend.emit();
                    this.resetForm();
                    this.isGeoZoneSubmitted = false;

                    this.toastrService.success('Geo Zone Created Successfully.');
                    console.log('this.result===>>>', result);

                })

        }
    }

    /*start dynamic add form fields */
    updateItem(task, i): FormGroup {


        console.log("task>>>", task);
        console.log("i>>>", i);


        this.mapping.push({
            zip_code: '',
            mappingId: null
        })

        return this.formBuilder.group({
            zip_code: task.zip_code,
            mappingId: task.id
        });
    }

    createItem(): FormGroup {

        console.log("createItem 0");

        this.mapping.push({
            zip_code: '',
            mappingId: null
        })


        return this.formBuilder.group({
            zip_code: '',
            mappingId: null
        });
    }

    createItemAfter(): FormGroup {

        console.log("createItemAfter 1");
        return this.formBuilder.group({
            zip_code: '',
            mappingId: null
        });
    }

    addItem(): void {

        console.log("addItem 1");

        this.mapping.push({
            zip_code: '',
            mappingId: null
        })
        if (this.geoZoneFormData.length) {
            this.geoZoneFormData.push({
                zip_code: '',
                addNewItemFlag: true,
                startIPCheckError: false,
                endIPCheckError: false,
                startIPRangeCheckError: false,
                endIPRangeCheckError: false,
                geoMappingSelectionFlag: false
            });
        }
        // if(this.update)
        //     this.addNewItemFlag=true;
        this.items = this.variableForm.get('items') as FormArray;
        this.items.push(this.createItemAfter());

    }

    delInput(index) {
        const arrayControl = this.variableForm.get('items') as FormArray;
        arrayControl.removeAt(index);
        this.deleteGeoMapping.push(this.geoZoneFormData[index].id);
        this.geoZoneFormData.splice(index, 1);
        console.log(this.geoZoneFormData)
        arrayControl.length == 0
    }
    /* end dynamic add form fields */

    isDeleteGeoMapping(event) {

        console.log('event Mayuri', event)
        if (event == 'Cancel') {
            this.isDeleteAction = false;
        }

        if (event == 'Yes') {
            this.isDeleteAction = false;
            this.delInput(this.deleteGeoMappingIndex);
        }

    }

    isDeleteGeoMappingYes(i) {
        this.deleteGeoMappingIndex = i;
    }


    //New Code for right side for from
    onContentReadyToReview() {
        //  this.commonService.changeloader(true);  
        // this.loader = true
        console.log("variableForm>>", this.variableForm.value.items.length);
        if (this.createGeoZoneForm.invalid) {

            this.contentReadyToReview = false;
            this.isGeoZoneSubmitted = true;
            this.commonService.changeloader(false);
            this.loader = false
            return;
        }
        else {

            //  let checkIPRangeFlag=this.checkIPRange();
            this.contentReadyToReview = true;
            this.shareMassage = 'review';

            this.isGeoZoneSubmitted = true;
            this.loader = false
            return;

        }

    }

    isContentReadyToReviewReceived(event) {

        console.log("we are in", event);
        this.contentReadyToReview = false;

        //New Code start
        if (event == 'No') {

            this.contentReadyToReview = false;

        }
        //New Code end

        if (event == 'Yes') {

            this.createGeoZoneForm.controls['contentState'].setValue(['Completed']);
            this.savecreateGeoZone();

        }
        if (event == 'Cancel') {

            this.createGeoZoneForm.controls['contentState'].setValue(['In-Progress']);
            this.savecreateGeoZone();

        }

    }

    resetForm() {

        //code for global loader start
        this.commonService.changeloader(false);

        this.update = false;
        this.isGeoZoneSubmitted = false;
        this.updateSend.emit();


        this.createGeoZoneForm = this.formBuilder.group({
            geoZoneName: ['', Validators.compose([Validators.required])],
            // latitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            latitude: [''],
            // mapAssetGroup:[[]],
            longitude: [''],
            // longitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            description: [''],
            isActive: ['1'],
            mapGeoMapping: [[]],
            deletedGeoMapping: [[]],
            id: [''],
            contentState: ['In-Progress'],
            publisherState: ['Un-published'],
            reviewerState: ['Un-approved'],
            created_by: [localStorage.getItem('ud')]
        });

        this.update = false;

        this.showCreateNewButton('show');

    }

    showCreateNewButton(isShow) {
        if (isShow == 'show') {
            this.isCreateNewShow = true;
        }
        else {
            this.isCreateNewShow = false;
        }
    }

    updateFilter(event) {
        console.log(event.target.value.length)
        this.filtergeoObj = { ip: event.target.value };
        if (event.target.value.length > 2) {
            this.getGeoZoneInfo(this.id, true, 0, 10)
            this.searcherrormsg = false
        } else {
            this.searcherrormsg = true
        }
    }

    clearsearch() {
        (<HTMLInputElement>document.getElementById('searchvalue')).value = null;
        console.log(document.getElementById('searchvalue'))
        this.filtergeoObj = {};
        this.getGeoZoneInfo(this.id, false, 0, 10)
        this.searcherrormsg = false
    }

}
